import React from 'react';
import { ValueEditor as DefaultValueEditor, useValueSelector } from 'react-querybuilder';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';

const CustomValueEditor = (props) => {
  const { handleOnChange, value, values, fieldData } = props;

  if (props.operator.toLowerCase().includes('in')) {
    let optionsList = values.map((el) => el.value);
    return (
      <Autocomplete
        multiple
        key={'autocomplete'}
        style={{
          minWidth: 400,
        }}
        value={value || []}
        options={optionsList}
        disableClearable={true}
        renderInput={(params) => <TextField {...params} variant="outlined" />}
        onChange={(event, selected) => {
          handleOnChange(selected);
        }}
        isOptionEqualToValue={(option, value) => option === value}
        filterOptions={(options, val) =>
          val.inputValue != '' ? options.filter((el) => el.includes(val.inputValue)) : options
        }
      />
    );
  } else if (props.operator.toLowerCase().includes('null')) {
    if (value != null) {
      handleOnChange(null);
    }

    return null;
  }

  return <DefaultValueEditor {...props} />;
};

export default CustomValueEditor;
